import React, { useCallback, useEffect, useRef, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import BellSound from "../../auctionsRoom/assets/bell_ring.mp3";
import TableUserOnline from "./tableUserOnline";
import ButtonsFunction from "./ButtonFunction";
import ImageNextRow from "./ImageNextRow";
import RightPannel from "./RightPannel";
import Current from "./Current";
import { auctionsLive } from "../../Model/DeclaratorModel";

import Announcement from "./announcenment";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

function View({ socketDeclarator, LiveData }) {
  const soundRef = useRef();
  const [userOnline, setUserOnline] = useState([]);
  const [Status, setStatus] = useState("");
  const [LiveDataNew, setGetLiveData] = useState("");

  const [openMessage, setOpenMessag] = React.useState(false);
  const [msg, setmsg] = React.useState("");
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenMessag(false);
  };


  function SoundTrip(){
    var resp =  new Audio(BellSound).play();
      if (resp!== undefined) {
          resp.then(_ => {
            new Audio(BellSound).play();
          }).catch(error => {
            //show error
          });
      }

  }
  
  

  const playSound = useCallback((data) => {
    const internetBids = (data?.bid_history || []).filter(
      (bid) => bid.bidder_type === "INTERNET BIDDER"
    );

    internetBids.forEach((_, index) => {
      window.setTimeout(() => {
        document.getElementById("sound")?.click();
      }, 500 * index);
    });
  }, []);

  const ListData = useCallback(async (val) => {
    try {
      const results = await auctionsLive();

      if (results.success === false) {
        alert(results.msg);
        return;
      }

      setGetLiveData(results);

      if (val === "NEXTSLOT" || val === "PASS") {
        playSound(results);
      }
    } catch (error) {
      console.error("Failed to refresh auction data:", error);
    }
  }, [playSound]);

  useEffect(() => {
    if (!socketDeclarator) return;
  
    // Audio setup
    soundRef.current = new Audio(BellSound);
  
    const handleJoin = (userId) => setUserOnline(userId?.users || []);
    
    const handleStatus = (data) => {
      setStatus(data.message);
      if (["NEXTSLOT", "PASS", "undo"].includes(data.message)) {
        ListData(data.message); 
      }
    };
  
    const handleBid = (data) => {
      setStatus("OPEN");
      if (data.status !== 1 && data.status !== 2) {
        // Mas mabilis kaysa sa .click()
        soundRef.current?.play().catch(e => console.log("Sound error:", e));
      }
      ListData();
    };
  
    // Listeners
    socketDeclarator.on("JointEvent", handleJoin);
    socketDeclarator.on("receive_status", handleStatus);
    socketDeclarator.on("receive_bid_amount", handleBid);
  
    // Connection Management
    socketDeclarator.on("connect", () => {
      setOpenMessag(true);
      setmsg("Connected");
    });
  
    socketDeclarator.on("disconnect", (reason) => {
      console.log("Disconnected due to:", reason);
      // Wag mag-reload agad. Hayaan ang auto-reconnect ng socket.io.
      if (reason === "io server disconnect") {
        socketDeclarator.connect();
      }
    });
  
    socketDeclarator.on("connect_error", (err) => {
      setmsg(err.message);
      setOpenMessag(true);
    });
  
    return () => {
      // Mas malinis na cleanup
      socketDeclarator.off("JointEvent", handleJoin);
      socketDeclarator.off("receive_status", handleStatus);
      socketDeclarator.off("receive_bid_amount", handleBid);
      socketDeclarator.off("connect");
      socketDeclarator.off("disconnect");
      socketDeclarator.off("connect_error");
    };
    // Siguraduhin na ang ListData ay naka-useCallback sa taas
  }, [socketDeclarator, ListData]);
  return (
    <div>
      <Box
        style={{
          // padding: "15px",
          backgroundColor: "#fff",
          borderRadius: "5px",
        }}
      >
        <Box style={{ padding: 5 }}>
          
        </Box>

        <Grid container>
          <Grid item xs={12} sm={5} style={{ border: "1px solid #ccc" }}>
            <Current
              LiveData={LiveDataNew === "" ? LiveData : LiveDataNew}
              Datastatus={Status}
            />

            <ButtonsFunction
              Datastatus={Status}
              socketDeclarator={socketDeclarator}
              LiveDataddd={LiveDataNew === "" ? LiveData : LiveDataNew}
            />
            <Divider></Divider>
            <ImageNextRow
              LiveData={LiveDataNew === "" ? LiveData : LiveDataNew}
            />
          </Grid>

          
          <Grid item xs={12} sm={7} style={{ border: "1px solid #ccc" }}>
            <RightPannel
              socketDeclarator={socketDeclarator}
              LiveData={LiveDataNew === "" ? LiveData : LiveDataNew}
            />



            <TableUserOnline
              socketDeclarator={socketDeclarator}
              userOnline={userOnline}
              LiveData={LiveDataNew === "" ? LiveData : LiveDataNew}
            />

            
<Button id="sound" onClick={SoundTrip} style={{display: "none"}}></Button>
            <Announcement
              socketDeclarator={socketDeclarator}
              message={
                LiveDataNew === ""
                  ? LiveData.announcement
                  : LiveDataNew.announcement
              }
            />
          </Grid>
          
        </Grid>


      </Box>

      <Snackbar
        open={openMessage}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={msg === "Connected" ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default View;
